import Cookies from 'js-cookie';
import { apiAction, logEntry } from '../utils/index';

import {
  GET_MODELVARIANTSETPOINTS,
  MODELVARIANTSETPOINTS_IS_LOADING,
  MODELVARIANTSETPOINTS_MANAGEMENT_ERROR,
  MODELVARIANTSETPOINTS_SET_CURRENT_PAGE,
  MODELVARIANTSETPOINTS_SET_PAGE_FILTER,
  MODELVARIANTSETPOINTS_SET,
  MODELVARIANTSETPOINTS_UPDATE_SAVE_STATUS,
  MODELVARIANTSETPOINTS_SET_CHANGE,
  MODELVARIANTSETPOINTS_SET_FILTERED_RESULTS,
  UPDATE_MODELVARIANTSETPOINTS_MODEL_SHOW_SCREEN,
  MODELVARIANTSETPOINTS_CLEANUP
} from '../constants/index';

import {
  MODELVARIANTSETPOINTS_MANAGEMENT,
  CREATE_MODELVARIANTSETPOINTS,
  UPDATE_MODELVARIANTSETPOINTS,
  DELETE_MODELVARIANTSETPOINTS
} from '../constants/logs';

const envName = process.env.REACT_APP_ENV_NAME_SHORT;

export const getModelVariantSetpointsThunk = (modelVaraintId, modelId,  widgetCode) => dispatch => {
  dispatch(getModelVariantSetpoints(modelVaraintId, modelId, widgetCode));
};

export const getModelVariantSetpoints = (modelVaraintId, modelId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/modelvariant/setpoints`,
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setAllModelVariantSetpointsListThunk(retData),
    onFailure: err => setModelVariantSetpointsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {ModelVariantId: modelVaraintId, ModelId: modelId},
    widgetcode: widgetCode
  });

export const setAllModelVariantSetpointsListThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let modelVariantSetpoints = (retData && retData.modelVariantSetpoints) || [];
  dispatch(setAllModelVariantSetpointsList(messageCode, modelVariantSetpoints));
};

export const setAllModelVariantSetpointsList = (messageCode, modelVariantSetpoints) => ({
  type: GET_MODELVARIANTSETPOINTS,
  payload: {
    data: {
      SetpointsList: modelVariantSetpoints,
      filteredResults: modelVariantSetpoints,
      isLoading: false,
      displayMessageCode: messageCode,
      showBanner: false
    }
  }
});

export const setLoadingStatus = isLoading => ({
  type: MODELVARIANTSETPOINTS_IS_LOADING,
  payload: { isLoading: isLoading }
});

export const setModelVariantSetpointsErrorThunk = err => dispatch => {
  let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
  messageCode = messageCode && messageCode.replace('[400]=>', '') && messageCode.replace('[403]=>', '');
  dispatch(setModelVariantSetpointsError(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setModelVariantSetpointsError(messageCode, false));
  }, 2500);
};

export const setModelVariantSetpointsError = (messageCode, status) => {
  return {
    type: MODELVARIANTSETPOINTS_MANAGEMENT_ERROR,
    payload: {
      data: {
        isOpSuccessfull: false,
        showBanner: status,
        isLoading: false,
        displayMessageCode: messageCode || ''
      }
    }
  };
};

export const setCurrentPage = currentPage => ({
  type: MODELVARIANTSETPOINTS_SET_CURRENT_PAGE,
  payload: { currentPage }
});

export const setPageFilter = filter => ({
  type: MODELVARIANTSETPOINTS_SET_PAGE_FILTER,
  payload: { filter }
});

export const describeModelVariantSetpointsThunk = (modelId, modelVariantSetpointId, widgetCode) => dispatch => {
  dispatch(describeModelVariantSetpoints(modelId, modelVariantSetpointId, widgetCode));
};

export const describeModelVariantSetpoints = (modelId, modelVariantSetpointId,  widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/modelvariant/setpoints`,
    data: {
      ModelId: modelId,
      ModelVariantSetpointId: modelVariantSetpointId
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setModelVariantSetpointsThunk(retData),
    onFailure: err => setModelVariantSetpointsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setModelVariantSetpointsThunk = ({retData}) => dispatch => {
  dispatch(setModelVariantSetpoints(retData));
};

export const setModelVariantSetpoints = data => ({
  type: MODELVARIANTSETPOINTS_SET,
  payload: data
});

export const saveModelVariantSetpointsThunk = (modelVariantSetpoints, widgetCode) => dispatch => {
  let url = '/management/modelvariant/setpoints/save';
  let actionName = modelVariantSetpoints.MarkAsDeleted
    ? DELETE_MODELVARIANTSETPOINTS
    : modelVariantSetpoints.SetpointId === 0
    ? CREATE_MODELVARIANTSETPOINTS
    : UPDATE_MODELVARIANTSETPOINTS;
  let log = logEntry(MODELVARIANTSETPOINTS_MANAGEMENT, actionName, modelVariantSetpoints);
  dispatch(saveModelVariantSetpoints(modelVariantSetpoints, url, log, widgetCode));
};

export const saveModelVariantSetpoints = (modelVariantSetpoints, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
    method: 'POST',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setModelVariantSetpointsStatusThunk(retData, modelVariantSetpoints),
    onFailure: err => setModelVariantSetpointsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      modelVariantSetpoint: modelVariantSetpoints,
      log: log
    },
    widgetcode: widgetCode
  });

export const setModelVariantSetpointsStatusThunk = (retData, modelVariantSetpoints) => dispatch => {
  dispatch(setModelVariantSetpointsStatus(retData, true, false));
  setTimeout(() => {
    //Hide the banner
    dispatch(setModelVariantSetpointsStatus(retData, false, false));
  }, 2500);
};

export const setModelVariantSetpointsStatus = (retData, status, redirect) => ({
  type: MODELVARIANTSETPOINTS_UPDATE_SAVE_STATUS,
  payload: {
    data: {
      SetpointsList: retData.modelVariantSetpoints,
      filteredResults: retData.modelVariantSetpoints,
      isOpSuccessfull: true,
      showBanner: status,
      isLoading: false,
      showAddEditScreen: redirect,
      displayMessageCode: retData.message || ''
    }
  }
});

export const setModelVariantSetpointsChangeThunk = retData => dispatch => {
  dispatch(setModelVariantSetpointsChange(retData));
};

export const setModelVariantSetpointsChange = retData => ({
  type: MODELVARIANTSETPOINTS_SET_CHANGE,
  payload: retData
});

export const setModelVariantSetpointsFilteredDataThunk = retData => dispatch => {
  dispatch(setModelVariantSetpointsFilteredData(retData));
};

export const setModelVariantSetpointsFilteredData = retData => ({
  type: MODELVARIANTSETPOINTS_SET_FILTERED_RESULTS,
  payload: retData
});

export const setModelVariantSetpointShowScreenStatusThunk = status => dispatch => {
  dispatch(setModelVariantSetpointShowScreenStatus(status));
};

export const setModelVariantSetpointShowScreenStatus = status => ({
  type: UPDATE_MODELVARIANTSETPOINTS_MODEL_SHOW_SCREEN,
  payload: { showAddEditScreen: status }
})


export const resetModelVariantSetpointsThunk = retData => dispatch => {
  dispatch(resetModelVariantSetpoints(retData));
};

export const resetModelVariantSetpoints = retData => ({
  type: MODELVARIANTSETPOINTS_CLEANUP,
  payload: retData
});